"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SemanticChip = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _chipConstants = require("../styled/chipConstants");
var _BaseChip = require("./BaseChip");
const SemanticChip = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    status,
    contentBefore,
    children,
    ...rest
  } = _ref;
  const colorVariant = _chipConstants.SEMANTIC_CHIP_COLORS[status];
  return /*#__PURE__*/_react.default.createElement(_BaseChip.BaseChip, (0, _extends2.default)({}, rest, {
    ref: ref,
    color: colorVariant,
    contentBefore: contentBefore
  }), children);
});
exports.SemanticChip = SemanticChip;
SemanticChip.displayName = "SemanticChip";
//# sourceMappingURL=SemanticChip.js.map